import styled from "styled-components";

export const StyledSocialMediaFixed = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 1000;
  width: 100vw;
`;
